import { z } from 'zod';

export const EMAIL_TEMPLATE_IDS = [
  'contact1',
  'contact2',
  'contact3',
  'booked',
  'rescheduled',
  'cancelled',
  'absent',
] as const;

export type EmailTemplateId = (typeof EMAIL_TEMPLATE_IDS)[number];

export const emailMessageSchema = z.object({
  to: z.array(z.email()).optional(),
  cc: z.array(z.email()).optional(),
  bcc: z.array(z.email()).optional(),
  callInReqIds: z.array(z.number().int()).optional(),
  templateId: z.enum(EMAIL_TEMPLATE_IDS),
  templateParams: z
    .object({
      name: z.string().optional(),
      startDateTime: z.string().optional(),
      endDateTime: z.string().optional(),
      location: z.string().optional(),
      deviceCount: z.number().optional(),
    })
    .optional(),
});

export type EmailMessage = z.infer<typeof emailMessageSchema>;
